import React, { Component } from 'react';

import Button from '@atlaskit/button';

import { StorageOfUniqueServices } from '@qality/common-service';

export default class ProjectIsntAvailable extends Component {
  goToProjects = async (): Promise<void> => {
    const url = StorageOfUniqueServices.get('URLService').getAllProjectsURL();
    StorageOfUniqueServices.get('AP').navigator.go('site', {
      absoluteUrl: url,
    });
  };

  render(): React.ReactNode {
    return (
      <div className='projects-error-page'>
        <h1 className='projects-error-page-heading'>
          This project isn&apos;t available
        </h1>
        <div className='projects-error-page-content'>
          <p>It may have been deleted or your permissions may have changed.</p>
          <p>
            <Button
              onClick={this.goToProjects}
              href='/projects'
              appearance='primary'
            >
              View a list of all projects
            </Button>
          </p>
        </div>
      </div>
    );
  }
}
